import React, { useRef } from 'react';
import { Adaptive, Layout } from 'fronton-react';
import { cx } from 'linaria';
import { HeaderModelData } from 'types/model';
import { useHideRegions } from 'common/hooks/use-hide-regions';
import {
  headerBackground,
  root,
  rootHiddenRegions,
  logoHiddenRegions,
  searchBarWrap,
  searchBarWrapHiddenRegions,
  subRoot,
  wrapper,
} from './styles';
import { LogoButton } from '../logo-button';
import { CityPicker } from '../city-picker';
import { MenuButton } from '../menu-button';
import { SearchBarRoot } from '../searchbar';
import { Profile } from '../profile';
import { BasketButton } from '../basket';
import {
  useCookieNotification,
  useLogo,
  useHamburgerMenuState,
  useRegionSelect,
  useCityPickerState,
} from '../../hooks';
import { useIsCheckout } from '../../hooks/use-is-checkout';
import { DeviceType } from 'types';
import { ProfileGroup } from './profile-group';

type Props = {
  model: HeaderModelData;
  isSticky?: boolean;
  isBot: boolean;
  isStickyVisible?: boolean;
  deviceType: DeviceType;
  withoutRegionModalButton?: boolean;
};

export const HeaderContent: React.FC<Props> = ({
  model,
  isSticky,
  isBot,
  isStickyVisible,
  deviceType,
  withoutRegionModalButton,
}) => {
  const { home } = useLogo(model);
  const { onMenuOpen } = useHamburgerMenuState();
  const isHideRegions = useHideRegions();
  const isRegionsVisible = !isHideRegions;
  const isCityPickerVisible = !withoutRegionModalButton && !isBot;

  const regionsMenuState = useCityPickerState();
  const { onMenuOpen: onRegionMenuOpen } = regionsMenuState;

  const containerRef = useRef<HTMLDivElement>(null);

  useCookieNotification();
  useRegionSelect({ model, onChangeClick: onRegionMenuOpen, isSticky });

  const isCheckout = useIsCheckout();

  const isMobile = deviceType === 'mobile';

  return (
    <>
      <div className={headerBackground} />
      <Layout>
        <div className={wrapper}>
          <div className={cx(root, isRegionsVisible ? '' : rootHiddenRegions)}>
            {!(isMobile && isSticky) && (
              <LogoButton
                home={home}
                className={isRegionsVisible ? '' : logoHiddenRegions}
                showMenuButton={!isCheckout}
              />
            )}
            {!isSticky && isRegionsVisible && (
              <Adaptive to="tablet" data-qa="city-picker-wrap-to-tablet">
                <CityPicker
                  model={model}
                  isVisible={isCityPickerVisible}
                  onRequestRegionChange={onRegionMenuOpen}
                />
              </Adaptive>
            )}
            <div className={subRoot} ref={containerRef}>
              {!isCheckout && <MenuButton onOpenMenuClick={onMenuOpen} />}
              {!isCheckout && (
                <div className={cx(searchBarWrap, isRegionsVisible ? '' : searchBarWrapHiddenRegions)}>
                  <SearchBarRoot
                    model={model}
                    ref={containerRef}
                    hasForm={(isSticky && isStickyVisible) || (!isStickyVisible && !isSticky)}
                  />
                </div>
              )}
              {isRegionsVisible && (
                <Adaptive from="tablet" data-qa="city-picker-wrap-from-tablet">
                  <CityPicker model={model} isVisible={true} onRequestRegionChange={onRegionMenuOpen} />
                </Adaptive>
              )}
            </div>
          </div>
          <ProfileGroup model={model} deviceType={deviceType} />
          {isCheckout && (
            <Adaptive to="tablet">
              <Profile model={model} />
              <BasketButton />
            </Adaptive>
          )}
        </div>
      </Layout>
    </>
  );
};
